import React from 'react';
import './styles.css';
import {Link} from 'react-router-dom';

export default function NoticiasCompletas(props){
let{encabezado,categoria,fecha,texto, portada, interes1, link1, tituloInteres1} = props;


    return(<>
     <div className='contenedorGeneralNoticia'>
        <div className='contenedorSeccionesNoticia'>
            <div className='contenedorInternoNoticia'>
                <div className='contenedorImagenNoticiaCompleta'>
                    <img src={portada} />
                </div>
                
                <div className='textoNoticia'>
                    <h1>{encabezado}</h1>
                    <h2>{categoria}</h2>
                    <h3>{fecha}</h3>
                    <div className='textoArticulo'>
                    <p>{texto}</p>
                    </div>

            </div>
        </div>
        <div className='contenedorInternoInteres'>
            <h1>TE PODRÍA INTERESAR</h1>
            <div className='contenedorContenidoInteres'>
                <div className='cardContenidoInteres'>
                    <Link to={link1}><div className='contenedorImagenCardContenidoInteres'>
                    <img src={interes1}/>
                    <h1>{tituloInteres1}</h1>
                </div></Link>
                </div>

            </div>
        </div>
    </div>
    </div>
    </>)
}